<template>
    <div>
        <top @mouse-enter="showCategory += 1" :keyword="''" @mouse-leave="showCategory -= 1"></top>

        <category :category="[]" :subCategory="{}" :showCategory="showCategory"></category>
        <div class="courseView">
            <div class="page-width">
                <div class="posnav"></div>
                <div class="box bd-all">
                    <div class="courseInfo">
                        <div class="image" id="courseImage">
                            <div id="view_flv" style="display:none;"></div>
                            <div class="course-pro0"></div>
                            <pic :src="course.logo_url_big" />
                        </div>
                        <div class="courseInfo-right">
                            <div class="name">{{ course.name }}</div>

                            <!--              <div class="star">
                <i class="edufont e-icon-ren"></i>  已有100人学习
                            </div>-->
                            <div>
                                <ul id="CouponList" class="clearfix"></ul>
                            </div>
                            <!--//优惠券领取 end-->

                            <div class="price">
                                <span class="price-info">
                                    <span>
                                        <font>¥</font>
                                        {{ coursePrice }}
                                    </span>
                                </span>
                                <span class="fan"></span>
                            </div>
                            <div class="clearfix introduction" v-html="course.introduction"></div>

                            <!---未购买end-->
                            <div id="bargain" class="bargain_activity"></div>
                            <div id="collageinfo"></div>
                        </div>
                        <div id="collagelist"></div>
                    </div>
                </div>
                <main class="courseTab" style="margin-top:20px; margin-bottom:30px;">
                    <h1 v-if="course.preview_url">预览视频</h1>
                    <div style="margin-bottom: 10px;" v-if="course.preview_url">
                        <ali-player :source="course.preview_url"></ali-player>
                    </div>

                    <h1>目录</h1>
                    <div
                        v-for="chapter in chapters"
                        class="menu"
                        style="margin-bottom: 10px;"
                        :key="chapter.id"
                    >
                        <h2>{{ chapter.name }}</h2>
                        <div class="memu-in clearfix Clearfix">
                            <ul>
                                <li v-for="section in chapter.section_list" :key="section.id">
                                    <a>
                                        {{ section.name }}
                                        <!--<span class="timel">(时长：{{ timeFormat(section.total_time) }})</span>-->
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <h1>讲师介绍</h1>
                    <div class="teachers">
                        <dl v-for="teacher in teachers" :key="teacher.id">
                            <dt>
                                <pic
                                    :src="teacher.photo_url"
                                    style="border-radius: 50%"
                                    alt
                                    width="100"
                                    height="100"
                                />
                            </dt>
                            <dd>
                                <h3>{{ teacher.name }}</h3>
                                <p>{{ teacher.level }}</p>
                                <p class="desc" v-html="teacher.teacher_desc"></p>
                            </dd>
                        </dl>
                        <div style="clear: both;"></div>
                    </div>
                </main>
            </div>
        </div>

        <bottom></bottom>
    </div>
</template>
<script>
import top from './top'
import category from './categoryView'
import bottom from './bottom'
import aliPlayer from '../components/aliPlayer'

export default {
    name: 'course',
    data() {
        let id = this.$router.currentRoute.params.id
        return {
            id: id,
            course: {},
            chapters: [],
            teachers: [],
            showCategory: 0
        }
    },
    computed: {
        coursePrice() {
            if (this.course.price) {
                return (Math.round(this.course.price * 100) / 100).toFixed(2)
            }
            return '0.00'
        }
    },
    methods: {
        timeFormat(time) {
            let h = 0
            let d = 0
            let s = 0
            let res = ''
            let temp = time % 3600
            if (time > 3600) {
                h = time / 3600
                if (temp != 0) {
                    if (temp > 60) {
                        d = temp / 60
                        if (temp % 60 != 0) {
                            s = temp % 60
                        }
                    } else {
                        s = temp
                    }
                }
            } else {
                d = time / 60
                if (time % 60 != 0) {
                    s = time % 60
                }
            }
            h = Math.floor(h)
            d = Math.floor(d)
            s = Math.floor(s)
            if (h < 10) {
                res = res + '0' + h
            } else {
                res = res + h
            }
            if (d < 10) {
                res = res + ':0' + d
            } else {
                res = res + ':' + d
            }
            if (s < 10) {
                res = res + ':0' + s
            } else {
                res = res + ':' + s
            }
            return res
        }
    },
    created() {
        var _this = this
        this.$http
            .get(this.$coursePath + '/index/course/' + this.id)
            .then(result => {
                if (result.data.status == 0) {
                    _this.course = result.data.data
                    _this.chapters = _this.course.chapter_list
                    _this.teachers = _this.course.teacher_list
                    if(_this.course.name){
                        document.title = _this.course.name
                    }
                }
            })
    },
    components: {
        top,
        category,
        bottom,
        'ali-player': aliPlayer
    }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';

main.courseTab h1 {
    font-size: 16px;
    color: #333;
    padding-left: 14px;
    margin-bottom: 10px;
    border-left: 4px solid #fb5b45;
    text-align: left;
    font-weight: normal;
}

main.courseTab h2 {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    background: #f8f8f8;
    font-weight: bold;
    text-align: left;
}

main.courseTab ul {
    margin-left: 20px;
}
main.courseTab li {
    text-align: left;
    margin: 5px;
}
main.courseTab li a {
    font-size: 14px;
    color: #666;
    line-height: 24px;
}

main.courseTab .teachers {
    background-color: white;
    padding-top: 20px;
}

main.courseTab .teachers dl dt {
    width: 130px;
    height: 130px;
}
main.courseTab .teachers dl dd,
main.courseTab .teachers dl dt {
    float: left;
}
main.courseTab .teachers dl dd {
    margin-left: 20px;
    width: 900px;
}
main.courseTab .teachers dl dd * {
    text-align: left;
}
main.courseTab .teachers dl dd .desc {
    font-size: 14px;
    margin-top: 5px;
}

.introduction {
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/course.vue